__turbopack_context__.v({
  "nav": "styles-module__TQLn7a__nav",
});
